import CryptoJS from "crypto-js";
import logo from "../../../assets/logo_login.jpeg"
import * as XLSX from 'xlsx';
import { loadingOverlay } from "vuetify-more-component";
import Component_anual from '../../../components/reporte_anual_usuarios/reporte_anual_usuarios.vue'

export default {

  components: {
    logo,
    loadingOverlay,
    Component_anual
  },

  data() {
    return {
      logo,
      text: "Copiar",
      copyText: '',
      itemaux: '',
      documento_aux: '',
      documento_aux_2: '',
      dialogEnviarNotificacion: false,
      loading: false,
      presentaciones: [],
      search: "",
      item: null,
      dialogpc: false,
      dialogrosISR: false,
      dialogrosIVA: false,
      dialogPago: false,
      facturas: [],
      retenciones: [],
      documento: null,
      documento_2: null,
      headers: [],
      item_info_usuario: null,
      loadingActualizacion: false,
      headers_PC: [
        {
          text: "CUI/DPI",
          align: "center",
          sortable: true,
          value: "cui"
        },
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
        },
        {
          text: "NIT",
          align: "center",
          sortable: true,
          value: "nit",
        },
        {
          text: "Contraseña agencia Virtual SAT",
          align: "center",
          sortable: false,
          value: "password_sat",
        },
        {
          text: "Total facturas ventas Q.",
          align: "end",
          sortable: true,
          value: "total_fatura"
        },
        {
          text: "Total Retenciones Q.",
          align: "end",
          sortable: true,
          value: "total_retencion"
        },
        {
          text: "Pago de impuesto Q.",
          align: "center",
          sortable: true,
          value: "pago"
        },
        {
          text: "Facturas",
          align: "center",
          sortable: true,
          value: "facturas"
        },
        {
          text: "Retenciones",
          align: "center",
          sortable: true,
          value: "retenciones"
        },
        {
          text: "Colaborador TIC asignado",
          align: "center",
          sortable: true,
          value: "asignado"
        },
        {
          text: "Fact. y Ret.",
          align: "center",
          sortable: true,
          value: "resumen"
        },
        {
          text: "Notificar al usuario para presentar declaracion",
          align: "center",
          sortable: true,
          value: "presentar"
        },
      ],
      headers_ROS: [
        {
          text: "CUI/DPI",
          align: "center",
          sortable: true,
          value: "cui"
        },
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
        },
        {
          text: "NIT",
          align: "center",
          sortable: true,
          value: "nit",
        },
        {
          text: "Contraseña agencia Virtual SAT",
          align: "center",
          sortable: false,
          value: "password_sat",
        },
        {
          text: "Total facturas ventas Q.",
          align: "end",
          sortable: true,
          value: "total_fatura"
        },
        {
          text: "Total Retenciones Q.",
          align: "end",
          sortable: true,
          value: "total_retencion"
        },
        {
          text: "Pago de impuesto Q.",
          align: "center",
          sortable: true,
          value: "pago"
        },
        {
          text: "Facturas",
          align: "center",
          sortable: true,
          value: "facturas"
        },
        {
          text: "Retenciones",
          align: "center",
          sortable: true,
          value: "retenciones"
        },
        {
          text: "Colaborador TIC asignado",
          align: "center",
          sortable: true,
          value: "asignado"
        },
        {
          text: "Fact. y Ret.",
          align: "center",
          sortable: true,
          value: "resumen"
        },
        {
          text: "Notificar para carga de facturas de compras",
          align: "center",
          sortable: false,
          value: "notificar"
        },
        {
          text: "Notificar al usuario para presentar declaracion",
          align: "center",
          sortable: true,
          value: "presentar"
        },
      ],
      fecha: {
        fecha: "",
        fecha_usuario: "",
      },
      item_aux: '',
      menu2: false,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      options: {
        locale: "en-US",
        prefix: "GTM Q",
        suffix: "",
        length: 12,
        precision: 2
      },
      usuario: -1,
      mes_declaracion: -1,
      anio: -1,
      impuesto_sin_retenciones: 0,
      meses: {
        1: "ENERO",
        2: "FEBRERO",
        3: "MARZO",
        4: "ABRIL",
        5: "MAYO",
        6: "JUNIO",
        7: "JULIO",
        8: "AGOSTO",
        9: "SEPTIEMBRE",
        10: "OCTUBRE",
        11: "NOVIEMBRE",
        12: "DICIEMBRE"
      },
      usuarios_reasignacion: [],
      loading_reasignacion: false,
      search_facturas_dialog: "",
      log_roles: [],
      tab: null,
      tipoRegimen: [],
      tipo_id: 1,
      tipo_nombre: 'Pequeño Contribuyente',
      items_formulario: [],
      dialogFacturas: false,
      facturasRecibidas: [],
      presentacion: null,
      mes_seleccionado: null,
      filas_tipo_registro_activos: [],
      filas_tipo_registro_activos_aux: [],
      columnasFacturasRecibidas: [
        {
          text: "Incluye",
          align: "center",
          sortable: true,
          value: "incluye",
        },
        {
          text: "Fecha de emisión",
          align: "center",
          sortable: true,
          value: "fecha_emision",
        },
        {
          text: "Tipo de registro",
          align: "center",
          sortable: true,
          value: "tipo_registro_id",
        },
        {
          text: "Número del DTE",
          align: "center",
          sortable: true,
          value: "numero_dte",
        },
        {
          text: "NIT del emisor",
          align: "center",
          sortable: true,
          value: "nit_emisor",
        },
        {
          text: "Nombre completo del emisor",
          align: "center",
          sortable: true,
          value: "nombre_emisor",
        },
        {
          text: "Moneda",
          align: "center",
          sortable: true,
          value: "moneda",
        },
        {
          text: "Monto (Gran Total)",
          align: "end",
          sortable: true,
          value: "monto",
        },
        {
          text: "Marca de anulado ",
          align: "center",
          sortable: true,
          value: "anulado",
        },
        {
          text: "IVA (monto de este impuesto)",
          align: "center",
          sortable: true,
          value: "monto_iva",
        },

      ],
      dialogAlerta: false,
      noMostrar: false,
      loading_notificacion: false,
      dialog_anual: false,
      presentacion_usuario: {},
      temp_table: false,
      items_formulario9: [
        {
          titulo_formulario: 'Facturas (Incluir las anuladas)',
          emitidas: 0,
          recibidas: 0,
        },
        {
          titulo_formulario: 'Factura y Declaración Única Centroamericana FYDUCA',
          emitidas: 0,
          recibidas: 0,
        },
        {
          titulo_formulario: 'Constancias de exención',
          emitidas: 0,
          recibidas: 0,
        },
        {
          titulo_formulario: 'Constancias de adquisición de insumos de producción local',
          emitidas: 0,
          recibidas: 0,
        },
        {
          titulo_formulario: 'Constancias de retención de IVA',
          emitidas: 0,
          recibidas: 0,
        },
        {
          titulo_formulario: 'Facturas especiales',
          emitidas: 0,
          recibidas: 0,
        },
        {
          titulo_formulario: 'Notas de crédito',
          emitidas: 0,
          recibidas: 0,
        },
        {
          titulo_formulario: 'Notas de débito',
          emitidas: 0,
          recibidas: 0,
        }
      ],
      dialogAnual: false,
      lodingData: false,
      isSelect: false,
    };
  },

  watch: {

    "itemaux.numero_formulario"() {
      if (this.itemaux.numero_formulario != null) this.itemaux.numero_formulario = this.itemaux.numero_formulario.trim();
    },

    "itemaux.numero_formulario_2"() {
      if (this.itemaux.numero_formulario_2 != null) this.itemaux.numero_formulario_2 = this.itemaux.numero_formulario_2.trim();
    },

    dialogrosIVA(val) {
      if (!val) {
        this.loadingActualizacion = true;
        this.presentarListado();
      }
    },

    dialogFacturas(val) {
      if (!val) {
        this.loadingActualizacion = true;
        this.presentarListado();
      }
    },


    async documento(value) {
      if (value === null || this.documento === null) {
        return;
      }

      try {
        let fr = new FileReader()
        fr.addEventListener("load", async (e) => {
          this.documento_aux = e.target.result;
          this.loading = false;
        });

        fr.readAsDataURL(value)

      } catch (error) {
        this.loading = false;

      }

    },

    async documento_2(value) {
      if (value === null || this.documento_2 === null) {
        return;
      }

      try {
        let fr = new FileReader()
        fr.addEventListener("load", async (e) => {
          this.documento_aux_2 = e.target.result;
          this.loading = false;
        });

        fr.readAsDataURL(value)

      } catch (error) {
        this.loading = false;

      }

    }
  },

  async created() {
    console.log('pago_declaracion.0');
    await this.getRegimenListado();
    await this.presentarListado();
    await this.getUsuariosReasignacion();
    await this.getTipo_registro_listado_activos();
    await this.getTipo_registro_listado_activos_calculadora();

    this.copyText = this.text

    let informacion_incriptada = sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-todo');
    if (informacion_incriptada != null) {
      let key_pass = atob(sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-tic'))
      let bytes = CryptoJS.AES.decrypt(informacion_incriptada, key_pass + "byTeamT0d0T1c");
      //Casteo de información a estring
      let informacion_desincriptada = bytes.toString(CryptoJS.enc.Utf8);
      //Casteo de JSON String a Object json
      let r = JSON.parse(informacion_desincriptada)
      this.log_roles = r.rol
      this.filtarInformacion(this.tipo_id, "PEQUEÑO CONTRIBUYENTE");
      this.usuario = r.usuario[0]
    }
  },

  computed: {
    totalRetenciones() {
      let total = 0
      this.retenciones.filter(x => {
        total = parseFloat(total) + parseFloat(x.total_retencion);
      });
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });

      return dollarUSLocale.format(parseFloat(total).toFixed(2));
    },

    totalFacturas() {
      let total = 0
      this.facturas.filter(x => {

        if (x.anulado != 1) {
          total = parseFloat(total) + parseFloat(x.monto);
        }
      });
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });

      this.impuesto_sin_retenciones = total * 0.05
      this.impuesto_sin_retenciones = dollarUSLocale.format(parseFloat(this.impuesto_sin_retenciones).toFixed(2))

      return dollarUSLocale.format(parseFloat(total).toFixed(2));
    },

    size() {
      const size = { xs: "x-small", sm: 'small', md: 'small', lg: 'small', xl: 'small' }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {}
    }
  },

  methods: {

    calculoDeFacturas() {
      /** filtra todos los datos de facturasRecibidas por cada elemento de filas_tipo_registro_activos*/
      this.filas_tipo_registro_activos.forEach(element => {
        // realiza la suma de todos los valores de total_sin_iva de facturasRecibidas que coincidan con el tipo_registro de filas_tipo_registro_activo
        element.total_sin_iva = this.facturasRecibidas.filter(factura => (factura.tipo_registro_id == element.id && factura.anulado == 0 && factura.incluye == 1)).reduce((a, b) => a + b.total_sin_iva, 0);
        // realiza la suma de todos los valores de iva de facturasRecibidas que coincidan con el tipo_registro de filas_tipo_registro_activo
        element.iva = this.facturasRecibidas.filter(factura => (factura.tipo_registro_id == element.id && factura.anulado == 0 && factura.incluye == 1)).reduce((a, b) => a + parseFloat(b.monto_iva), 0);
        // realiza la suma de todos los valores de total_con_iva de facturasRecibidas que coincidan con el tipo_registro de filas_tipo_registro_activo
        element.total_con_iva = parseFloat(element.total_sin_iva + element.iva).toFixed(2);
      });

      // realiza la suma de todas las filas de facturasRecibidas del tipo de registro total_sin_iva
      this.filas_tipo_registro_activos[this.filas_tipo_registro_activos.length - 1].total_sin_iva = this.facturasRecibidas.filter(factura => (factura.anulado == 0 && factura.incluye == 1)).reduce((a, b) => a + b.total_sin_iva, 0);
      // realiza la suma de todas las filas de facturasRecibidas del tipo de registro iva
      this.filas_tipo_registro_activos[this.filas_tipo_registro_activos.length - 1].iva = this.facturasRecibidas.filter(factura => (factura.anulado == 0 && factura.incluye == 1)).reduce((a, b) => a + parseFloat(b.monto_iva), 0);
      // realiza la suma de todas las filas de facturasRecibidas del tipo de registro total_con_iva
      this.filas_tipo_registro_activos[this.filas_tipo_registro_activos.length - 1].total_con_iva = parseFloat(this.filas_tipo_registro_activos[this.filas_tipo_registro_activos.length - 1].total_sin_iva + this.filas_tipo_registro_activos[this.filas_tipo_registro_activos.length - 1].iva).toFixed(2);


    },

    async postFacturasIncluidasPorColaborador() {
      try {
        this.loading = true;
        let r = await this.$store.state.services.usuarioService.postFacturasIncluidas({ facturas: this.facturasRecibidas, presentacion: this.presentacion });
        if (r.data.success) {
          this.loading = false;
          this.$toast.success("Facturas incluidas correctamente.");
        } else {
          this.loading = false;
          this.dialogFacturas = false;
          this.$toast.warning("No cuentas con facturas en el mes de " + this.meses[mes] + " del año " + new Date().getFullYear() + ".");
        }
      } catch (error) {
        this.$toast.error("Ha ocurrido un error al intentar incluir las facturas seleccionadas.")
      }
    },

    // marca todas las facturas como incluidas
    marcarTodas() {
      this.facturasRecibidas.forEach(item => {
        if (item.anulado == 0) {
          item.incluye = 1;
        }
      });
      this.calculoDeFacturas();

    },

    // desmarca todas las facturas como incluidas
    desmarcarTodas() {
      this.facturasRecibidas.forEach(item => {
        if (item.anulado == 0) {
          item.incluye = 0;
        }
      });
      this.calculoDeFacturas();

    },

    color(item, row) {

      if (row.item.anulado == 1) return;

      if (row.item.incluye == 1) {
        row.item.incluye = 0;
        row.select(false);
        this.calculoDeFacturas();
      } else {

        if (!this.noMostrar) this.dialogAlerta = true;

        row.item.incluye = 1;
        row.select(true);
        this.calculoDeFacturas();
      }
    },

    itemRowBackground: function (item) {
      if (item.anulado == 1) {
        return 'style-3'
      } else {
        return item.incluye === 1 ? 'style-1' : 'style-2'
      }
    },

    async getTipo_registro_listado_activos_calculadora() {
      try {
        let r = await this.$store.state.services.administradorService.getTipo_registro_listado_activos();
        r.data.data.filter(item => { item.total_sin_iva = 0, item.iva = 0, item.total_con_iva = 0 })
        this.filas_tipo_registro_activos = r.data.data;
        this.filas_tipo_registro_activos_aux = [...r.data.data];
        this.filas_tipo_registro_activos.push({ id: -1, descripcion: "TOTAL", total_sin_iva: 0, iva: 0, total_con_iva: 0 })
      } catch (error) {
        this.$toast.error("No es posible obtener el listado de regitros activos")
      }
    },

    async getFacturasUsuario(mes, anio, usuario_id) {
      this.loading = true;
      let r = await this.$store.state.services.usuarioService.getFacturasUsuario(mes, anio, usuario_id);
      if (r.data.success) {
        this.loading = false;
        this.dialogFacturas = true;
        this.facturasRecibidas = r.data.data.data;
        this.presentacion = r.data.data.presentacion;
        this.calculoDeFacturas();
      } else {
        this.loading = false;
        this.$toast.warning("No cuentas con facturas en el mes de " + mes + " del año " + anio + ".");
      }
    },

    async realizar_notificacion(item) {
      item.loading = true;
      this.item_info_usuario = item;
      let fecha = item.fecha_presentacion.split("-");
      let mes = fecha[1];
      this.mes_seleccionado = mes;
      let anio = fecha[0];
      let usuario_id = item.usuario_id;
      await this.getFacturasUsuario(mes, anio, usuario_id);
      item.loading = false;

    },

    async confirmar_notificacion_facturas_cliente() {
      let body = {
        usuario_id: this.item_info_usuario.usuario_id,
        presentacion_id: this.item_info_usuario.id,
        empleado: true
      }

      try {
        this.loading_notificacion = true;
        let r = await this.$store.state.services.presentacionService.notificacion_para_seleccion_facturas(body);
        if (r.data.success) {
          this.$toast.success("Notificación enviada correctamente al usuario para que incluya sus facturas");
          this.loading_notificacion = false;
        } else {
          this.$toast.error("No es posible notificar al usuario para que incluya sus facturas")
          this.loading_notificacion = false;

        }
        this.loading_notificacion = false;
      } catch (error) {
        this.loading_notificacion = false;
        this.$toast.error("No es posible notificar al usuario para que incluya sus facturas")
      }
    },

    exportarExcel() {
      let fecha = this.item_info_usuario.fecha_presentacion.split("-");
      let mes = fecha[1];
      let anio = fecha[0];
      let usuario = this.item_info_usuario.nombre;
      let data = XLSX.utils.json_to_sheet(this.facturasRecibidas)
      const workbook = XLSX.utils.book_new()
      const filename = 'Facturas Recibidas ' + this.meses[parseInt(mes)].toString().toUpperCase() + '_' + anio + "_" + usuario
      XLSX.utils.book_append_sheet(workbook, data, 'Facturas Recibidas')
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },

    async getTipo_registro_listado_activos() {
      try {
        let r = await this.$store.state.services.administradorService.getTipo_registro_listado_activos();
        r.data.data.filter(item => { item.base = 0, item.creditos = 0 })
        this.items_formulario = r.data.data;
        // ordena los items por orden
        this.items_formulario.sort((a, b) => (a.orden > b.orden) ? 1 : -1)
        this.items_formulario.push({ titulo_formulario: "Sumatoria de las columnas BASE y CRÉDITOS ", id: -2, orden: "-1", base: 0, creditos: 0 })

      } catch (error) {
        this.$toast.error("No es posible obtener el listado de registros activos")
      }
    },

    async getRegimenListado() {
      try {
        this.loading_regimenes = true;
        let r = await this.$store.state.services.administradorService.getRegimenListado();
        this.tipoRegimen = r.data.data;

      } catch (error) {
        this.$toast.error("No es posible obtener los tipos de regímen")
      }
    },

    async filtarInformacion(id, descripcion) {
      console.log('filtarInformacion');
      this.tipo_id = id;
      if (this.tipo_id == 1) {
        if (this.temp_table === true) {
          this.headers = this.headers_PC;
        } else {
          this.temp_table = true;
        }
      } else if (this.tipo_id == 2) {
        this.headers = this.headers_ROS;
      }
      this.tipo_nombre = descripcion;
      await this.presentarListado();
    },

    convertirnumero(numero) {
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(Math.abs(parseFloat(numero).toFixed(2)))
    },

    async copyCode(tipo, item) {

      switch (tipo) {
        case 1:
          await navigator.clipboard.writeText(this.totalFacturas.replace(",", ""));
          this.copyText = "Copiado"
          break;
        case 2:
          await navigator.clipboard.writeText(this.totalRetenciones.replace(",", ""));
          this.copyText = "Copiado"
          break;
        case 3:
          await navigator.clipboard.writeText(item);
          this.copyText = "Copiado"
          break;
        default:
          break;
      }

    },
    reset() {
      this.copyText = this.text
    },
    // allowedDates: (date) => date <= (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    pago() {
      this.dialogPago = true;
    },

    async getUsuariosReasignacion() {
      try {
        let r = await this.$store.state.services.administradorService.getUsuariosReasignacion();

        this.usuarios_reasignacion = r.data.data;
      } catch (error) {
      }
    },

    async reasignar(id_asignado, id_presentacion) {
      let request = { presentacion_id: id_presentacion, usuario_id: id_asignado };
      try {
        this.loading_reasignacion = true;
        let r = await this.$store.state.services.administradorService.putReasignarUsuario(request);
        this.loading_reasignacion = false;
        this.presentarListado();
      } catch (error) {
      }
    },

    // ver dialog
    async verDialog(item, opc) {
      console.log('verDialog'),
        console.log('item', item);
      console.log('opc', opc);
      item.loading = true;

      this.item_aux = item;
      console.log("item_aux:", this.item_aux);
      console.log("this.items_formulario9", this.items_formulario9);
      this.items_formulario9[0].emitidas = this.item_aux.total_facturas_emitidas;
      this.items_formulario9[0].recibidas = this.item_aux.total_facturas_recibidas;
      this.items_formulario9[2].recibidas = this.item_aux.total_facturas_recibidas_CIV;
      this.items_formulario9[4].recibidas = this.item_aux.total_documentos_retenciones;
      this.items_formulario9[6].emitidas = this.item_aux.total_NC_ventas;
      this.items_formulario9[6].recibidas = this.item_aux.total_NC_compras;
      this.items_formulario9[7].emitidas = this.item_aux.total_ND_ventas;
      this.items_formulario9[7].recibidas = this.item_aux.total_ND_compras;

      let fecha_solicitada = item.fecha_presentacion;
      fecha_solicitada = fecha_solicitada.split("-");
      let mes = parseInt(fecha_solicitada[1]);
      let mes_declaracion = mes;
      let anio = parseInt(fecha_solicitada[0])

      this.mes_declaracion = mes_declaracion;
      this.anio = anio;
      this.loading = true;

      switch (opc) {
        case 1:
          await this.getPresentarFacturas(item);
          await this.getPresentarRetenciones(item);
          this.item = item;
          this.dialogpc = true;
          break;
        case 2:
          await this.getPresentarFacturas(item);
          await this.getPresentarRetenciones(item);
          this.itemaux = item;
          if (opc === 1) {
            this.dialogrosISR = true;
          } else if (opc === 2) {
            this.dialogrosIVA = true;
            let base_acumlada = 0;
            let creditos_acumulados = 0;
            for (const key in item.ros) {
              const CFOL = item.ros[key];
              if (CFOL.tipo_registro_id != 9) {
                let item_formulario = this.items_formulario.find(
                  (item) => item.id === CFOL.tipo_registro_id
                );
                item_formulario.base = CFOL.monto_sin_iva;
                item_formulario.creditos = CFOL.monto_iva;
                base_acumlada += parseFloat(CFOL.monto_sin_iva);
                creditos_acumulados += parseFloat(CFOL.monto_iva);
              }
            }
            // accede al ultime item de items_formulario
            this.items_formulario[this.items_formulario.length - 1].base = base_acumlada;
            this.items_formulario[this.items_formulario.length - 1].creditos = creditos_acumulados;
          }
          break;
        case 3:
          // this.dialog_anual = true;
          // let { fecha_presentacion, usuario_id } = item;
          // this.presentacion_usuario = { fecha_presentacion, usuario_id };
          // break;
          console.log('this.fecha.fecha_usuario:', this.fecha.fecha_usuario);
          //split para obtener el anio
          let anio = this.fecha.fecha_usuario.split("/")[2];
          console.log('anio:', anio);

          try {
            let r = await this.$store.state.services.administradorService.obtenerCierreAnualISR(anio,item.usuario_id);
            console.log('obtenerCierreAnualISR:', r);
            this.item_aux = r.data.data[0];
            console.log("item_aux:", this.item_aux);
            this.dialogAnual = true;
          } catch (error) {
            console.log('error:', error);
            this.$toast.error("No es posible obtener el cierre anual del ISR")
          }
      }

      this.loading = false;
      item.loading = false;
    },

    async pagoFacturas(item) {
      this.itemaux = item;
      this.dialogEnviarNotificacion = true;
    },

    //aqui entra el nuevo consumo
    async confirmar_notificacion() {
      this.loading = true;
      if (this.$refs.form.validate()) {

        let body = {
          presentacion_id: this.itemaux.id,
          documento: this.documento_aux,
          numero_formulario: this.itemaux.numero_formulario,
          documento_2: this.documento_aux_2,
          numero_formulario_2: this.itemaux.numero_formulario_2,
          impuesto_isr: this.itemaux.pago,
          impuesto_iva: this.itemaux.impuesto_pagar_debitos
        }
        let r = await this.$store.state.services.presentacionService.enviarCorreoNotificacion(body);
        if (r.data.success) {
          this.$toast.success("El cliente ha sido notificado, te recordamos estar pendiente de revisar el estado del formulario a presentar");
          this.itemaux.numero_formulario = '';
          this.itemaux.numero_formulario_2 = '';
          this.itemaux = '';
          this.dialogEnviarNotificacion = false;
          this.loading = false;
          this.documento = null;
          this.documento_aux = null;
          this.documento_2 = null;
          this.documento_aux_2 = null;
          this.presentarListado();
        } else {
          this.$toast.error("No es posible notificar al usuario");
          this.dialogEnviarNotificacion = false;
          this.loading = false;
        }
      }
    },

    async presentarListado() {
      console.log('presentarListado');
      this.fecha.fecha_usuario = this.date.split("-")
        .reverse()
        .join("/");
      this.fecha.fecha = this.date;
      this.fecha.regimen_id = this.tipo_id;
      try {
        this.loading = true;
        let r =
          await this.$store.state.services.presentacionService.presentarListado(this.fecha);
        // let datas = r.data.data.filter(x => x.val_retencion !== 0);
        // this.presentaciones = datas.filter(x => x.pago_realizado === 0);
        r.data.data.filter((x) => { x.loading = false })
        this.presentaciones = r.data.data;
        this.loading = false;
        this.loadingActualizacion = false;
      } catch (error) {
        this.loading = false;
        this.loadingActualizacion = false;

        this.$toast.error(
          "Ocurrió un error al obtener los datos de las declaraciones"
        );
      }
    },

    // presentar facturas
    async getPresentarFacturas(item) {
      try {
        let r =
          await this.$store.state.services.presentacionService.getPresentarFacturas(item.id);
        this.facturas = r.data.data;
      } catch (error) {
        this.$toast.error(
          "Ocurrió un error al obtener los datos de las declaraciones"
        );
      }
    },

    async getPresentarRetenciones(item) {
      try {
        let r =
          await this.$store.state.services.presentacionService.getPresentarRetenciones(item.id);
        this.retenciones = r.data.data;
      } catch (error) {
        this.$toast.error(
          "Ocurrió un error al obtener los datos de las declaraciones "
        );
      }
    },
  },

  mounted() {
    console.log('/pago_declaracion');
    console.log('tipo_id:', this.tipo_id);
    console.log('usuario.rol_id', this.usuario.rol_id)
  }
};
